import { HttpAxiosBuilder } from "./httpAxiosBase";

export const HttpAxiosRequest = HttpAxiosBuilder();
